import { render } from "./Appearance.vue?vue&type=template&id=9d2fa406&ts=true"
import script from "./Appearance.vue?vue&type=script&lang=ts"
export * from "./Appearance.vue?vue&type=script&lang=ts"

import "./Appearance.vue?vue&type=style&index=0&id=9d2fa406&lang=css"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Settings/Appearance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d2fa406"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d2fa406', __exports__)) {
    api.reload('9d2fa406', __exports__)
  }
  
  module.hot.accept("./Appearance.vue?vue&type=template&id=9d2fa406&ts=true", () => {
    api.rerender('9d2fa406', render)
  })

}


export default __exports__